<template>
  <wrapper-page ref="wrapper">
    <div class="">UNDER CONSTRUCTION DOCUMENTS</div>
  </wrapper-page>
</template>

<script>
import WrapperPage from "@/components/layout/WrapperPage.vue";

export default {
  name: "ResourcesGenerateDocuments",
  components: { WrapperPage },
  data() {
    return {};
  },
  methods: {},
};
</script>
